/*
 * Warm the feed's downloads shortly after the site or app opens, so /feed
 * (and the home preview) usually has them ready when the reader gets there.
 * Each loader is memoised for the session (`once`), so useFeed reuses these
 * requests instead of starting new ones. The other sections are bundled or
 * personal (Firestore), and the saved feed (persist.js) covers those.
 *
 * Skipped on Save-Data and on 2G connections.
 */
import { loadServerFeed } from './server';
import { loadCatalogue } from './providers/audio';
import { loadLettersIndex } from './providers/letters';

const DELAY_MS = 1500; // after the first page has had its turn

let started = false;

export function prefetchFeed() {
  if (started || typeof window === 'undefined') return;
  started = true;
  const conn = navigator.connection;
  if (conn?.saveData || /(^|-)2g$/.test(conn?.effectiveType || '')) return;
  const run = () =>
    Promise.allSettled([loadServerFeed(), loadCatalogue(), loadLettersIndex()]);
  const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 0));
  setTimeout(() => idle(run, { timeout: 3000 }), DELAY_MS);
}
